import React, { FC } from 'react';

import classNames from 'classnames';

export enum HeaderSize {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  HERO = 'hero',
}

export interface HeaderInterface {
  omitSizeString?: boolean;
  size: HeaderSize;
  text: any;
  applyUpperCasing?: boolean;
  align?: 'left' | 'center' | 'right';
  classes?: string;
  role?: string;
  isFullWidth?: boolean;
  hoverEffect?: boolean;
}

const mapSizeToClassName = {
  h1: 'text-h-x3 md:text-h-x2',
  h2: 'text-h-x4 md:text-h-x3',
  h3: 'text-h-x5 md:text-h-x4',
  h4: 'text-h-x6 md:text-h-x6',
  hero: 'text-h-x3 md:text-h-x1',
};

const containsHTML = (str: string): boolean => {
  const htmlTagPattern = /<\/?[a-z][\s\S]*>/i;
  return htmlTagPattern.test(str);
};

const HeaderText: FC<HeaderInterface> = ({
  omitSizeString,
  size = HeaderSize.H1,
  text,
  align,
  classes = '',
  role = 'heading',
  applyUpperCasing,
  isFullWidth = true,
  hoverEffect,
}) => {
  const element = size == HeaderSize.HERO ? 'h1' : size;
  const isString = typeof text === 'string';
  const hasHTML = isString && containsHTML(text);

  if (!text) {
    return null;
  }

  const baseProps = {
    role,
    className: classNames('font-bold', {
      'text-charcoal-v2': !hoverEffect,
      [classes]: classes,
      'w-full': isFullWidth,
      'title-container': align === 'center',
      [`text-${align}`]: align,
      [mapSizeToClassName[size]]: !omitSizeString,
      uppercase: applyUpperCasing,
    }),
    'data-testid': `text-headerText-${size}`,
  };

  const props = hasHTML
    ? { ...baseProps, dangerouslySetInnerHTML: { __html: text } }
    : baseProps;

  return React.createElement(element, props, hasHTML ? undefined : text);
};

export default React.memo(HeaderText);
